import './index.scss'
// import AnimatedLetters from '../AnimatedLetters'
// import { useEffect, useState } from 'react'
import ArtistImage from '../../assets/images/portrait-1.jpeg'
// import ArtistImage2 from '../../assets/images/portrait-2.jpeg'
import TreeGuy from '../../assets/images/tree-guy.png'
import Mystery from '../../assets/images/Mystery.png'

const About = () =>  {
    // const [letterClass, setLetterclass] = useState('text-animate')

    // useEffect(() => {
    //     return setTimeout(() => {
    //         setLetterclass('text-animate-hover')
    //     }, 4000)
    // }, [])
    return (
        <div className='container about-page'>
            <div className='image-container-about'>
                <img src={ArtistImage} className='artist-image' alt='About Me' />
                {/* <img src={ArtistImage2} className='artist-image2' alt='About Me' /> */}
                <img src={TreeGuy} className='tree-guy-about' alt='Tree Guy' />
                <img src={Mystery} className='mystery-about' alt='Mystery' />
            </div>
            <div className='text-zone'>
                <h1>
                    {/* <AnimatedLetters
                        letterClass={letterClass}
                        strArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
                        idx={15}
                    /> */}
                    About Me
                </h1>
                <h2>Bio</h2>
                <p>
                    Born and based in Houston, Texas. His childhood was informed by the grief of losing a parent at a young age, and not being able to fit in amongst peers. Solitary walks in nature, and the dreamlike escapism of video games, anime and fantasy in general inspired him to develop a sense of appreciation for the mind and the natural world around him as well as the worlds he couldn't see. This sense of sincere wonder and fervent curiosity about the enigmatic nature of the world continues to inform his work as he brings his characters and inner world to life through his surrealist expressions.
                </p>
                <p>
                    My art is innately and thematically tied to emotionality, self acceptance, mental health and the environment. My works are shaped by cultural influences leading back to my Creole and Haitian ancestry, in addition to my queer identity highlighting the human need to belong in shared space, and how I've chosen to reshape my cultural and diasporic grief. These multimedia acrylic works are born out of a desire to invite the viewer into a vivid world of contemplation and introspection through the lenses of my surrealist expressions and characters. The works being high gloss acrylic canvas pieces with additions of pulp paper, and corrugated fiberboard composed in diverse ways that invites both imagination and introspective dialogue. The intentionally bright and expressive colors communicate with the bleak backdrop and accents arranged in the pieces to consider multiple truths and perspectives.✨
                </p>
                {/* <p>
                    I'm a third paragrapgh
                </p> */}
            </div>
            
        </div>
    )
}

export default About